import { useState, useEffect } from "react";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Pie } from "react-chartjs-2";
import { TextInput, Slider, Center } from "@mantine/core";
import { useForm } from "@mantine/form";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

Chart.register(CategoryScale);
const formatter = new Intl.NumberFormat('en-IN', {
	style: 'currency',
	currency: 'INR',
	maximumFractionDigits: 2,
  });
  const formatter1 = new Intl.NumberFormat('en-IN', {
	style: 'currency',
	currency: 'INR',
	maximumFractionDigits: 0,
  });


const GoldenKey = () => {
	const form = useForm({
		
		initialValues: {
			installmentAmt: 10000,
			numInstallment: 11,
			makingCharges: 20,
		},

		validate: {
			installmentAmt: (value) => (value <= 5000 ? null : "Amount must be greater than 0"),
		},
	});
    
	const getDiscount = () => {
		if (form.values.numInstallment < 11) {
			return 0;
		} else {
			return (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges) / 100;
		}
	};
	const nbsp = "\xa0";
	const getTotal =() => form.values.installmentAmt * form.values.numInstallment;
	const getDiscountPerc = () => Math.trunc((getDiscount() / getWorth()) * 100);
	const getROI = () => Math.trunc((getDiscount() / (form.values.installmentAmt * form.values.numInstallment)) * 100);
	const getWorth = () => getDiscount() + form.values.installmentAmt * form.values.numInstallment;

	const handleSliderBeforeChange = () => {
		return false; // Returning false prevents the slider value from changing
	  };
	  
	const getChartData = () => {
		const discount = getDiscount();
		const amount = getTotal();
		const Data = [
			{
				label: `Benefit Offered(${formatter.format(discount)}) `,
				amount: getDiscount(),
		  },
			{
				label: `Amount Paid (${formatter.format(amount)})`,
				amount: getTotal(),
		  },
			
		
			
		  
		];
			
		
	

		return {
			labels: Data.map((data) => data.label),
			datasets: [
				{
					backgroundColor: [ "#f6b800", "#c7931d",],


					data: Data.map((data) => data.amount),
					
					borderColor: "#555",
					borderWidth: 2,
				},
			],
		};
	};

	const [chartData, setChartData] = useState(getChartData());

	useEffect(() => {
		setChartData(getChartData());
	}, [form.values.installmentAmt, form.values.makingCharges, form.values.numInstallment]);

	return (
		<div className="page-content">
			{/* <h1 style={{ color: "#980717", fontStyle: "italic", padding: "20px" }}>Golden Key Plan</h1> */}
			<div style={{ display: "flex", gap: "10px" }}>
		
			<div className="container-fluid">
				<div className="row">
				<div className="col-md-4">
				<form onSubmit={form.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
					{/* <TextInput
						withAsterisk
						label="Installment Amount:"
						placeholder="1,00,000"
						{...form.getInputProps("installmentAmt")}
					/> */}
			
					<div style={{ display: "flex", flexDirection: "column", gap: "3px",  }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<label>Installment Amount:</label>
							<div>{formatter1.format(form.values.installmentAmt)}</div>
						</div>
						<Slider  {...form.getInputProps("installmentAmt")} min={5000} max={100000} step={1000}  styles={(theme) => ({
                                                                                track: {
                                                                                  backgroundColor: '#f6b800', // Track color
                                                                                },
                                                                                thumb: {
                                                                                  backgroundColor: '#ffffff',
																				  border: '4px solid #c7931d', // Thumb color
                                                                                },
                                                                                bar: {
                                                                                  backgroundColor: '#f6b800', // Color of the filled part
                                                                                },
                                                                              })}/>
					</div>


				

					<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <label>No. of Installments :</label>
    <div>{form.values.numInstallment}</div>
  </div>
  <div style={{ position: "relative", width: "100%" }}>
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "8px",
        background: "#f6b800",
        borderRadius: "5px",
        zIndex: 0,
      }}
    />
    <div
      style={{
        position: "absolute",
        width: "calc(100% * 11 / 11)", // This sets the width to 100% when the value is 11
        height: "8px",
        background: "#f6b800",
        borderRadius: "5px",
        zIndex: 1,
      }}
    />
    <input
      type="range"
      min={1}
      max={11}
      step={1}
      value={form.values.numInstallment}
      disabled // Disable the slider interaction
      style={{
        width: "100%",
        height: "8px",
        cursor: "default",
        opacity: 0,
        zIndex: 2,
      }}
    />
  </div>
</div>
<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<label>Net Making Charges:</label>
							<div>{form.values.makingCharges}%</div>
						</div>
						<Slider {...form.getInputProps("makingCharges")} min={2} max={40} 
       
	   styles={(theme) => ({
		track: {
		  backgroundColor: '#f6b800', // Track color
		},
		thumb: {
		  backgroundColor: '#ffffff',
		  border: '4px solid #c7931d', // Thumb color
		},
		bar: {
		  backgroundColor: '#f6b800', // Color of the filled part
		},
	  })}
     />
					</div>

				</form>
				<br></br>
				</div>
				<div className="col-md-5">


				<table className="table table-striped">
<thead>
<tr>
<td>Total Amount Paid:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></td>

</tr>
</thead>
<tbody>
<tr>
<td>Benefit Offered:</td>
<td> <div className="bold" style={{ textAlign: "right" }}>{formatter.format(getDiscount())}</div></td>
</tr>

<tr>
<td>Redemption Value:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(getWorth())} </div></td>
</tr>

</tbody>
</table>

				
					{/* <div>
						<label>Total Amount Paid</label>
						<div className="bold">{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div>
					</div>

					<div>
						<label>Total Benefit Offered</label>
						<div className="bold">{formatter.format(getDiscount())}</div>
					</div>

					<div>
						<label>Get Jewellery Worth</label>
						<div className="bold">{formatter.format(getWorth())} for free</div>
					</div> */}


					<div className="card">
  <div className="card-body">
  <b>Benefit:</b><br></br>
  <b>No Making charges</b> on Total Amount Paid i.e., <b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}  {' '}    </b> (Effectively you get benefit worth <b>{formatter.format(getDiscount())}</b> in this example)

  </div>

</div>
<br></br>

					{/* <div>
						<label>You would effectively pay</label>
						<div className="bold">{form.values.installmentAmt * form.values.numInstallment}</div>
					</div> */}

					{/* <div>
						<label>Effective Discount</label>
						<div className="bold">{getDiscountPerc()}%</div>
					</div>

					<div>
						<label>Effective Return on Investment</label>
						<div className="bold">{getROI()}%</div>
					</div>

					<div>
						<label>Annualized ROI</label>
						<div className="bold">{(getROI() * 12) / 6}%</div>
					</div> */}
				
				</div>
				<div className="col-md-3">
				<div style={{ flex: 1 }} >
					<Pie data={chartData} height={128} width={128}/>
				</div>
				</div>
				</div>
				<BrowserView>
				<div className="row indicator">
					<div className="col-md-3"></div>
					<div className="col-md-6"><p className="calculatorFor"><a href="/?scheme_name=ratna&show_menu=0&show_title=0" style={{color:"white"}} className="previous round">&#8592;</a> Sample Calculator For <b className="jppName">Golden Key </b><a href="/?scheme_name=kubera&show_menu=0&show_title=0" className="next round" style={{color:"white"}}>&#8594;</a></p>  </div>
					<div className="col-md-3">
    <div className="card-body" style={{textAlign:"center"}}>
        <br/>

        <p style={{fontSize:"13px"}}>
            The benefits and other details shown above are only indicative.
        </p>

        For more details contact Bhima Helpline
        <a href="tel:1800-121-9076">1800-121-9076</a>
    </div>
</div>
				</div> 
				</BrowserView> 
				<MobileView>
				<div className="row indicator">
					<div className="col-md-3"></div>
						<div className="col-md-6">
    <p style={{fontSize:"12px", color:"#777", textAlign:"center"}}>
        The benefits and other details shown above are only indicative.
    </p>

    <p className="calculatorFor">
        Sample Calculator For <b className="jppName">Golden Key</b>
    </p>
</div>
					<div className="col-md-3"></div>
				</div>
				<div className="row indicator">
					<div className="col-md-5"></div>
					<div className="col-md-2" style={{textAlign:"center"}}><a href="/?scheme_name=ratna&show_menu=0&show_title=0" className="previous round" style={{color:"white"}}>&#8592;</a>{nbsp}{nbsp}{nbsp}

<a href="/?scheme_name=kubera&show_menu=0&show_title=0" className="next round" style={{color:"white"}}>&#8594;</a></div>	
<div className="col-md-5"><div className="card-body" style={{textAlign: "center"}}><br />For more details contact Bhima Helpline<a href="tel:1800-121-9076">1800-121-9076</a></div></div>
				</div>
				</MobileView>
				
				

				</div>
				
			</div>
			</div>
		
	);
};

export default GoldenKey;

